import React from 'react'
import { Link } from 'react-router-dom'
// import Container from '@material-ui/core/Container';
// import Grid from '@material-ui/core/Grid';
import HorizontalTabs from '../components/HorizontalTabs';


function feestructure() {
  const tabs = [
    // { title: 'Bhoomika', content: () => <div>
    
    // <div className='cam-lower-sec'>
    // <h1 className='title'>Session - 2025 - 2026</h1>
    // <h2>Fee structure for Class Bhoomika</h2>
    // </div>
   
    // <div className='syllubus-data'>
    // <div className='cam-lower-table'>
     
    //  {/* <h1>table data baki ha abhi</h1> */}
     
    //  <table>
    //    <thead>
    //     <tr>
    //       <th colSpan={5}>For New Student One Time Charges at the Time of Admission</th>
        
    //     </tr>
    //      <tr>
          
    //        <th>Prospectus & Registration Fee</th>
    //        <th>Admission Fee</th>
    //        <th>Development Fee</th>
    //        <th colSpan={2}>Caution Money (Refundable)</th>
     
           
    //      </tr>
    //    </thead>
    //    <tbody>
    //      <tr>
    //        <td><b>₹ 700</b></td>
    //        <td><b>₹ 25000</b></td>
    //        <td><b>₹ 8000</b></td>
    //        <td colSpan={2}><b>₹ 5000</b></td>

    //      </tr>
    //      <tr>
    //      <td rowSpan={2}><b>School Fee</b></td>
    //        <td><b>Quarter – 1 (April – June)</b></td>
    //        <td><b>Quarter – 2 (July – Sept)</b> </td>
    //        <td><b>Quarter – 3 (Oct – Dec)</b></td>
    //        <td><b>Quarter – 4 (Jan – March)</b></td>
    //      </tr>
    //      <tr>
       
    //        <td><b>₹ 26260</b></td>
    //        <td><b>₹ 26260</b></td>
    //        <td><b>₹ 26260</b></td>
    //        <td><b>₹ 26260</b></td>
    //      </tr>
    //      <tr>
    //        <td><b>Annual Misc. Fee</b></td>
    //        <td><b>₹ 3150</b></td>
    //        <td><b>₹ 0</b></td>
    //        <td><b>₹ 0</b></td>
    //        <td><b>₹ 0</b></td>

    //      </tr>

    //     </tbody>
    //          </table>
    //          </div> 
    // </div>
    // </div> },
    // { title: 'Class ', content: () => <div>
    
    // <div className='cam-lower-sec'>
    // <h1 className='title'>Session - 2025 - 2026</h1>
    // <h2>Fee structure for Class Bhoomika</h2>
    // </div>
   
    // <div className='syllubus-data'>
    // <div className='cam-lower-table'>
     
    //  {/* <h1>table data baki ha abhi</h1> */}
     
    //  <table>
    //    <thead>
    //     <tr>
    //       <th colSpan={5}>For New Student One Time Charges at the Time of Admission</th>
        
    //     </tr>
    //      <tr>
          
    //        <th>Prospectus & Registration Fee</th>
    //        <th>Admission Fee</th>
    //        <th>Development Fee</th>
    //        <th colSpan={2}>Caution Money (Refundable)</th>
     
           
    //      </tr>
    //    </thead>
    //    <tbody>
    //      <tr>
    //        <td><b>₹ 700</b></td>
    //        <td><b>₹ 25000</b></td>
    //        <td><b>₹ 8000</b></td>
    //        <td colSpan={2}><b>₹ 5000</b></td>

    //      </tr>
    //      <tr>
    //      <td rowSpan={2}><b>School Fee</b></td>
    //        <td><b>Quarter – 1 (April – June)</b></td>
    //        <td><b>Quarter – 2 (July – Sept)</b> </td>
    //        <td><b>Quarter – 3 (Oct – Dec)</b></td>
    //        <td><b>Quarter – 4 (Jan – March)</b></td>
    //      </tr>
    //      <tr>
       
    //        <td><b>₹ 26260</b></td>
    //        <td><b>₹ 26260</b></td>
    //        <td><b>₹ 26260</b></td>
    //        <td><b>₹ 26260</b></td>
    //      </tr>
    //      <tr>
    //        <td><b>Annual Misc. Fee</b></td>
    //        <td><b>₹ 3150</b></td>
    //        <td><b>₹ 0</b></td>
    //        <td><b>₹ 0</b></td>
    //        <td><b>₹ 0</b></td>

    //      </tr>

    //     </tbody>
    //          </table>
    //          </div> 
    // </div>
    // </div> },
    { title: 'Bhoomika (Nursery) ', content: () => <div>
    
    <div className='cam-lower-sec'>
    <h1 className='title'>Session - 2026 - 2027</h1>
    <h2>Fee structure for Class Bhoomika (Nursery)</h2>
    </div>
   
    <div className='syllubus-data'>
    <div className='cam-lower-table'>
     
     {/* <h1>table data baki ha abhi</h1> */}
     
     <table>
       <thead>
        <tr>
          <th colSpan={5}>For New Student One Time Charges at the Time of Admission</th>
        
        </tr>
         <tr>
          
           <th>Prospectus & Registration Fee</th>
           <th>Admission Fee</th>
           <th>Development Fee</th>
           <th colSpan={2}>Caution Money (Refundable)</th>
     
           
         </tr>
       </thead>
       <tbody>
         <tr>
           <td><b>₹ 700</b></td>
           <td><b>₹ 25000</b></td>
           <td><b>₹ 8000</b></td>
           <td colSpan={2}><b>₹ 5000</b></td>

         </tr>
         <tr>
         <td rowSpan={2}><b>School Fee</b></td>
           <td><b>Quarter – 1 (April – June)</b></td>
           <td><b>Quarter – 2 (July – Sept)</b> </td>
           <td><b>Quarter – 3 (Oct – Dec)</b></td>
           <td><b>Quarter – 4 (Jan – March)</b></td>
         </tr>
         <tr>
       
           <td><b>₹ 28890</b></td>
           <td><b>₹ 28890</b></td>
           <td><b>₹ 28890</b></td>
           <td><b>₹ 28890</b></td>
         </tr>
         <tr>
           <td><b>Annual Misc. Fee</b></td>
           <td><b>₹ 3150</b></td>
           <td><b>₹ 0</b></td>
           <td><b>₹ 0</b></td>
           <td><b>₹ 0</b></td>

         </tr>

        </tbody>
             </table>
             </div> 
    </div>
    </div> },
    { title: 'Vatika (L.K.G.), Praveshika (H.K.G.)', content: () => <div>
    
    <div className='cam-lower-sec'>
    <h1 className='title'>Session - 2026 - 2027</h1>
    <h2>Fee structure for Classes Vatika (L.K.G.), Praveshika (H.K.G.)</h2>
    </div>
   
    <div className='syllubus-data'>
    <div className='cam-lower-table'>
     
     {/* <h1>table data baki ha abhi</h1> */}
     
     <table>
       <thead>
        <tr>
          <th colSpan={5}>For New Student One Time Charges at the Time of Admission</th>
        
        </tr>
         <tr>
          
           <th>Prospectus & Registration Fee</th>
           <th>Admission Fee</th>
           <th>Development Fee</th>
           <th colSpan={2}>Caution Money (Refundable)</th>
     
           
         </tr>
       </thead>
       <tbody>
         <tr>
           <td><b>₹ 700</b></td>
           <td><b>₹ 25000</b></td>
           <td><b>₹ 8000</b></td>
           <td colSpan={2}><b>₹ 5000</b></td>

         </tr>
         <tr>
         <td rowSpan={2}><b>School Fee</b></td>
           <td><b>Quarter – 1 (April – June)</b></td>
           <td><b>Quarter – 2 (July – Sept)</b> </td>
           <td><b>Quarter – 3 (Oct – Dec)</b></td>
           <td><b>Quarter – 4 (Jan – March)</b></td>
         </tr>
         <tr>
       
           <td><b>₹ 32780</b></td>
           <td><b>₹ 32780</b></td>
           <td><b>₹ 32780</b></td>
           <td><b>₹ 32780</b></td>
         </tr>
         <tr>
           <td><b>Annual Misc. Fee</b></td>
           <td><b>₹ 3150</b></td>
           <td><b>₹ 0</b></td>
           <td><b>₹ 0</b></td>
           <td><b>₹ 0</b></td>

         </tr>

        </tbody>
             </table>
             </div> 
    </div>
    </div> },
    { title: 'Clase I - V ', content: () => <div>
    
    <div className='cam-lower-sec'>
    <h1 className='title'>Session - 2026 - 2027</h1>
    <h2>Fee structure for Classes (I - V)</h2>
    </div>
   
    <div className='syllubus-data'>
    <div className='cam-lower-table'>
     
     {/* <h1>table data baki ha abhi</h1> */}
     
     <table>
       <thead>
        <tr>
          <th colSpan={5}>For New Student One Time Charges at the Time of Admission</th>
        
        </tr>
         <tr>
          
           <th>Prospectus & Registration Fee</th>
           <th>Admission Fee</th>
           <th>Development Fee</th>
           <th colSpan={2}>Caution Money (Refundable)</th>
     
           
         </tr>
       </thead>
       <tbody>
         <tr>
           <td><b>₹ 700</b></td>
           <td><b>₹ 25000</b></td>
           <td><b>₹ 8000</b></td>
           <td colSpan={2}><b>₹ 5000</b></td>

         </tr>
         <tr>
         <td rowSpan={2}><b>School Fee</b></td>
           <td><b>Quarter – 1 (April – June)</b></td>
           <td><b>Quarter – 2 (July – Sept)</b> </td>
           <td><b>Quarter – 3 (Oct – Dec)</b></td>
           <td><b>Quarter – 4 (Jan – March)</b></td>
         </tr>
         <tr>
       
           <td><b>₹ 32780</b></td>
           <td><b>₹ 32780</b></td>
           <td><b>₹ 32780</b></td>
           <td><b>₹ 32780</b></td>
         </tr>
         <tr>
           <td><b>Annual Misc. Fee</b></td>
           <td><b>₹ 3150</b></td>
           <td><b>₹ 0</b></td>
           <td><b>₹ 0</b></td>
           <td><b>₹ 0</b></td>

         </tr>

        </tbody>
             </table>
             </div> 
    </div>
    </div> },
    { title: 'Cambridge Class VI - VIII', content: () => <div>
    
    <div className='cam-lower-sec'>
    <h1 className='title'>Session - 2026 - 2027</h1>
    <h2>Fee structure for Classes (VI - VIII) (Cambridge)</h2>
    </div>
   
    <div className='syllubus-data'>
    <div className='cam-lower-table'>
     
     {/* <h1>table data baki ha abhi</h1> */}
     
     <table>
       <thead>
        <tr>
          <th colSpan={5}>For New Student One Time Charges at the Time of Admission</th>
        
        </tr>
         <tr>
          
           <th>Prospectus & Registration Fee</th>
           <th>Admission Fee</th>
           <th>Development Fee</th>
           <th colSpan={2}>Caution Money (Refundable)</th>
     
           
         </tr>
       </thead>
       <tbody>
         <tr>
           <td><b>₹ 700</b></td>
           <td><b>₹ 25000</b></td>
           <td><b>₹ 8000</b></td>
           <td colSpan={2}><b>₹ 5000</b></td>

         </tr>
         <tr>
         <td rowSpan={2}><b>School Fee</b></td>
           <td><b>Quarter – 1 (April – June)</b></td>
           <td><b>Quarter – 2 (July – Sept)</b> </td>
           <td><b>Quarter – 3 (Oct – Dec)</b></td>
           <td><b>Quarter – 4 (Jan – March)</b></td>
         </tr>
         <tr>
       
           <td><b>₹ 40370</b></td>
           <td><b>₹ 40370</b></td>
           <td><b>₹ 40370</b></td>
           <td><b>₹ 40370</b></td>
         </tr>
         <tr>
           <td><b>Annual Misc. Fee</b></td>
           <td><b>₹ 3150</b></td>
           <td><b>₹ 0</b></td>
           <td><b>₹ 0</b></td>
           <td><b>₹ 0</b></td>

         </tr>

        </tbody>
             </table>
             </div> 
    </div>
    </div> },
    { title: 'IGCSE Class IX - X ', content: () => <div>

<div className='cam-lower-sec'>
    <h1 className='title'>Session - 2026 - 2027</h1>
    <h2>Fee structure for Classes (IX - X) (IGCSE)</h2>
    </div>

    <div className='syllubus-data'>
    <div className='cam-lower-table'>
     
     {/* <h1>table data baki ha abhi</h1> */}
     
     <table>
       <thead>
        <tr>
          <th colSpan={5}>For New Student One Time Charges at the Time of Admission</th>
        
        </tr>
         <tr>
          
           <th>Prospectus & Registration Fee</th>
           <th>Admission Fee</th>
           <th>Development Fee</th>
           <th colSpan={2}>Caution Money (Refundable)</th>
     
           
         </tr>
       </thead>
       <tbody>
         <tr>
           <td><b>₹ 700</b></td>
           <td><b>₹ 25000</b></td>
           <td><b>₹ 8000</b></td>
           <td colSpan={2}><b>₹ 5000</b></td>

         </tr>
         <tr>
         <td rowSpan={2}><b>School Fee</b></td>
           <td><b>Quarter – 1 (April – June)</b></td>
           <td><b>Quarter – 2 (July – Sept)</b> </td>
           <td><b>Quarter – 3 (Oct – Dec)</b></td>
           <td><b>Quarter – 4 (Jan – March)</b></td>
         </tr>
         <tr>
         
           <td><b>₹ 43470</b></td>
           <td><b>₹ 43470</b></td>
           <td><b>₹ 43470</b></td>
           <td><b>₹ 43470</b></td>
         </tr>
         <tr>
           <td><b>Annual Misc. Fee</b></td>
           <td><b>₹ 3150</b></td>
           <td><b>₹ 0</b></td>
           <td><b>₹ 0</b></td>
           <td><b>₹ 0</b></td>

         </tr>

        </tbody>
             </table>
             </div> 
    </div>

    </div> },
    { title: 'IBDP XI- XII', content: () => <div>

<div className='cam-lower-sec'>
    <h1 className='title'>Session - 2026 - 2027</h1>
    <h2>Fee structure for Classes (XI – XII) (IBDP)</h2>
    </div>

    <div className='syllubus-data'>
    <div className='cam-lower-table'>
     
     {/* <h1>table data baki ha abhi</h1> */}
     
     <table>
       <thead>
        <tr>
          <th colSpan={5}>For New Student One Time Charges at the Time of Admission</th>
        
        </tr>
         <tr>
          
           <th>Prospectus & Registration Fee</th>
           <th>Admission Fee</th>
           <th>Development Fee</th>
           <th>IB Registration Fee</th>
           <th>Caution Money (Refundable)</th>
     
           
         </tr>
       </thead>
       <tbody>
         <tr>
           <td><b>₹ 700</b></td>
           <td><b>₹ 35000</b></td>
           <td><b>₹ 8000</b></td>
           <td><b>₹ 6000</b></td>
           <td><b>₹ 5000</b></td>

         </tr>
         <tr>
           <td rowSpan={2}><b>School Fee</b></td>
           <td><b>Quarter – 1 (April – June)</b></td>
           <td><b>Quarter – 2 (July – Sept)</b> </td>
           <td><b>Quarter – 3 (Oct – Dec)</b></td>
           <td><b>Quarter – 4 (Jan – March)</b></td>
         </tr>
         <tr>
           {/* <td><b>School Fee</b></td> */}
           <td><b>₹ 59940</b></td>
           <td><b>₹ 59940</b></td>
           <td><b>₹ 59940</b></td>
           <td><b>₹ 59940</b></td>
         </tr>
         <tr>
           <td><b>Annual Misc. Fee</b></td>
           <td><b>₹ 3150</b></td>
           <td><b>₹ 0</b></td>
           <td><b>₹ 0</b></td>
           <td><b>₹ 0</b></td>

         </tr>

        </tbody>
             </table>
             </div> 
    </div>

    </div> },
  


 
  ];
  return (
    <div>
     
     
      {/* <Container maxWidth={false}>
      <Grid container spacing={0}>
      <Grid item xs={12} md={5}>
      <h1> hellox</h1>
      </Grid>
      </Grid>
      </Container> */}
      
      <div className='ibdp-hero-sec'>
        <img src='img/infa6.webp'/>

      </div>

      
        <div className='feestructure'>
        <HorizontalTabs tabs={tabs} />

        </div>




    </div>
  )
}

export default feestructure
